import './App.css';
import TicTacToe from './Components/TicTactToe/TicTacToe';

function App() {
  return (
    <div>
      <TicTacToe/>
    </div>
  );
}

export default App;
